import React, {Fragment} from 'react';
import _ from 'lodash';
import withUpload from "../../hoc/withUpload";
import {SpinLoader} from "../Loader";


class UploadMultipleGallery extends React.Component {
    constructor(props){
        super(props);
        this.id = _.random(0, 99999);
        this.state = {
            errorMessage: '',
            preview: this.props.preview,
        };

        this.props.loadFile('',this.props.multFileData)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.preview !== this.props.preview){
            this.setState({preview: this.props.preview});
            let type = this.props.multFileData.type.substr(0, 5);
            this.props.uploadFile({kind : type === "video" ? "video" : "gallery"});
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    onUploadError({response}){
        this.props.reset();
        let message = '';
        switch (response.statusCode) {
            case 413:
                message = `Fichier trop lourd, maximum accepté : ${response.errors.maxFileSizeStr}`;
                break;
            case 415:
                message = `Fichier non accepté, sont acceptés : ${response.errors.allowedTypes.join(', ')}`;
                break;
            default :
                message = 'Envoi du fichier impossible, erreur système inconnue';
                break;
        }
        this.setState({errorMessage: message, preview: ""})
    }

    onUploadSuccess(data){
        this.props.getUploadData && this.props.getUploadData(data, this.state.preview);
    }

    render(){
        return this.props.uploadProgress.percentCompleted !== 100 && (
            <Fragment>
                {this.props.showLoader ? (
                    <div className={"upload-loading"}>
                        <SpinLoader className={"small"}/>
                    </div>
                ) : (
                    <div className={"uploading-media"}>
                        <div className={`media-block`}>
                            <div className={"white-borders"}
                                 style={{background: `url(${this.props.preview}) 0% 0% / cover`}} />
                        </div>
                        {this.props.uploading && (
                            <div className={"column"}>
                                <div className="progress-bar-small">
                                    <div className="progress-bar-inside"
                                         style={{width: `${this.props.uploadProgress.percentCompleted}%`}} />
                                </div>
                                <span className="file-data">
                            Temps estimé : {`${Math.round(this.props.uploadProgress.eta / 1000)}s (${this.props.uploadProgress.kos}ko/s)`}
                        </span>
                            </div>
                        )}
                    </div>
                )}
            </Fragment>

        )
    }
}

export default withUpload(UploadMultipleGallery);